module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    style: ({
      backgroundColor: _vm.styles.general.background_color
    }),
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "z-index": "-1"
    }
  }, [_c('v-tabs', {
    staticStyle: {
      "top": "280px",
      "position": "absolute",
      "z-index": "1",
      "overflow-y": "hidden"
    },
    attrs: {
      "fixed": "",
      "centered": "",
      "scrollable": false,
      "grow": ""
    },
    model: {
      value: (_vm.groupPageTab),
      callback: function($$v) {
        _vm.groupPageTab = $$v
      },
      expression: "groupPageTab"
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "justify-space-around": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-2 text-xs-center",
    staticStyle: {
      "overflow-y": "hidden"
    },
    attrs: {
      "sm12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-0 mr-4",
    staticStyle: {
      "overflow-y": "hidden"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "white",
    staticStyle: {
      "height": "65px",
      "overflow-y": "hidden",
      "min-height": "100%"
    },
    attrs: {
      "color": "white",
      "dark": "",
      "fixed": ""
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": _vm.styles.general.theme_color_dark
    }
  }), _vm._v(" "), _c('v-tabs-item', {
    staticClass: "secondary--text",
    attrs: {
      "href": "#tab-1"
    }
  }, [_c('div', {
    staticClass: "tabItem"
  }, [_c('v-icon', {
    staticClass: "secondary--text"
  }, [_vm._v("home")]), _vm._v(" "), _c('span', {
    staticClass: "secondary--text"
  }, [_vm._v("Home")])], 1)]), _vm._v(" "), _c('v-tabs-item', {
    staticClass: "secondary--text",
    attrs: {
      "href": "#tab-2"
    }
  }, [_c('div', {
    staticClass: "tabItem"
  }, [_c('v-icon', {
    staticClass: "secondary--text"
  }, [_vm._v("date_range")]), _vm._v("\n                    Events\n                  ")], 1)]), _vm._v(" "), _c('v-tabs-item', {
    staticClass: "secondary--text",
    attrs: {
      "href": "#tab-3"
    }
  }, [_c('div', {
    staticClass: "tabItem"
  }, [_c('v-icon', {
    staticClass: "secondary--text"
  }, [_vm._v("group")]), _vm._v("\n                    Members\n                  ")], 1)]), _vm._v(" "), (_vm.user && _vm.group && _vm.user.uid === _vm.group.adminId) ? _c('v-tabs-item', {
    staticClass: "secondary--text",
    attrs: {
      "href": "#tab-4"
    }
  }, [_c('div', {
    staticClass: "tabItem"
  }, [_c('v-icon', {
    staticClass: "secondary--text"
  }, [_vm._v("notifications")]), _vm._v("\n                    Notifications \n                  ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.user.uid === _vm.group.adminId) ? _c('v-tabs-item', {
    staticClass: "secondary--text",
    attrs: {
      "href": "#tab-5"
    }
  }, [_c('div', {
    staticClass: "tabItem"
  }, [_c('v-icon', {
    staticClass: "secondary--text"
  }, [_vm._v("settings")]), _vm._v("\n                    Settings\n                  ")], 1)]) : _vm._e()], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "39px",
      "width": "103%",
      "height": "250px",
      "z-index": "3",
      "margin-left": "-29px",
      "margin-right": "40px",
      "overflow-x": "hidden"
    },
    style: ({
      'backgroundImage': ("url(" + (_vm.tempImgUrl || _vm.coverPhoto) + ")"),
      'backgroundSize': 'cover',
    }),
    attrs: {
      "id": "group-cover-photo"
    }
  }, [_c('input', {
    ref: "imgupload",
    staticClass: "hidden",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.setTemp
    }
  }), _vm._v(" "), (!_vm.modify.changePhoto.hide && _vm.user.uid === _vm.group.adminId) ? _c('div', {
    staticClass: "change-photo"
  }, [(!_vm.modify.changePhoto.save) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleModify('changePhoto')
      }
    }
  }, [_vm._v("Change Cover photo")]) : _vm._e(), _vm._v(" "), (_vm.modify.changePhoto.save) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveCoverPhoto.apply(null, arguments)
      }
    }
  }, [_vm._v("Save Cover Photo")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }), _vm._v(" "), (!_vm.modify.groupTitle) ? _c('div', {
    staticClass: "group-title"
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "align-center": "",
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h4', {
    staticClass: "white--text text-outline",
    staticStyle: {
      "font-weight": "900"
    }
  }, [_vm._v(_vm._s(this.group && this.group.name ? this.group.name : 'Loading...'))]), _vm._v(" "), _c('p', {
    staticClass: "white--text text-outline",
    staticStyle: {
      "font-weight": "500",
      "margin-top": "-10px",
      "margin-left": "-10px",
      "font-size": "18px"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "medium": ""
    }
  }, [_vm._v("group")]), _vm._v("\n              " + _vm._s(Object.keys(this.group.members).length) + " Members\n            ")], 1)])], 1), _vm._v(" "), _c('v-layout')], 1) : _vm._e(), _vm._v(" "), (!_vm.modify.reposition.hide && _vm.user.uid === _vm.group.adminId) ? _c('div', {
    staticClass: "position-photo"
  }, [(!_vm.modify.reposition.save) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleModify('reposition')
      }
    }
  }, [_vm._v("Reposition Cover photo")]) : _vm._e(), _vm._v(" "), (_vm.modify.reposition.save) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.savePosition.apply(null, arguments)
      }
    }
  }, [_vm._v("Save Position")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5",
    staticStyle: {
      "z-index": "1",
      "position": "relative"
    }
  }, [_c('v-tabs', {
    attrs: {
      "fixed": "",
      "centered": "",
      "scrollable": false,
      "grow": ""
    },
    model: {
      value: (_vm.groupPageTab),
      callback: function($$v) {
        _vm.groupPageTab = $$v
      },
      expression: "groupPageTab"
    }
  }, [_c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-1"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "postion": "relative",
      "z-index": "2"
    },
    attrs: {
      "xs12": "",
      "md3": "",
      "hidden-xs-only": "",
      "hidden-sm-only": ""
    }
  }, [_c('v-card', {
    staticClass: "mr-3"
  }, [_c('v-card-text', [_c('v-layout', {
    staticClass: "mb-2",
    attrs: {
      "justify-center": ""
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "src": this.group.logo || '/static/images/group-icon.png'
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "600"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    })
  }, [_vm._v("About " + _vm._s(this.group && this.group.name ? this.group.name : 'Loading...'))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(this.group && this.group.description ? this.group.description : 'Loading...'))]), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "py-5",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "600"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    })
  }, [_vm._v("Members")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    on: {
      "click": function($event) {
        _vm.groupPageTab = 'tab-3'
      }
    }
  }, [_vm._v("See All ")])])])], 1), _vm._v(" "), (this.group) ? _c('v-layout', {
    staticClass: "mt-2"
  }, [_vm._l((_vm.firstFiveMembers), function(user, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs2": ""
      }
    }, [(user) ? _c('v-avatar', [_c('img', {
      attrs: {
        "src": user.avatar
      }
    })]) : _vm._e()], 1)
  }), _vm._v(" "), _c('br')], 2) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [((_vm.group.members[_vm.user.uid] && _vm.group.members[_vm.user.uid].approvalStatus == 1 && _vm.privileges.groups && _vm.privileges.groups.post_to_group) || _vm.group.adminId === _vm.user.uid) ? _c('new-activity', {
    attrs: {
      "firstname": _vm.user.firstname,
      "type": _vm.type,
      "extraData": _vm.setGroupPostData,
      "extraUrl": _vm.extraUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.feed), function(item) {
    return _c('timeline', {
      key: item.postKey,
      attrs: {
        "item": item,
        "user": item.user,
        "itemKey": item.postKey,
        "type": _vm.type,
        "extraUrl": _vm.extraUrl
      }
    })
  }), _vm._v(" "), (!_vm.feed.length) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "40px"
    }
  }, [_c('h5', {
    staticClass: "black--text"
  }, [_vm._v("No Group Activity yet")])]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-flex', {
    staticClass: "load-data-div",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('button', {
    staticClass: "btn btn--raised btn--round theme--dark load-more",
    attrs: {
      "color": _vm.styles.general.theme_color_light
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.counterPost()
      }
    }
  }, [_vm._v("Load More")])])], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "hidden-xs-only": ""
    }
  }, [_c('TopEvents', {
    attrs: {
      "groupId": _vm.strippedGroupId,
      "add": _vm.group.members[_vm.user.uid].approvalStatus == 1
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-2"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('events-tab', {
    attrs: {
      "groupId": _vm.strippedGroupId
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-3"
    }
  }, [_c('v-container', [_c('v-layout', [_c('members', {
    attrs: {
      "group": _vm.group,
      "groupId": _vm.strippedGroupId
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-4"
    }
  }, [_c('notifications', {
    attrs: {
      "groupId": _vm.strippedGroupId
    }
  })], 1)], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-5"
    }
  }, [_c('settings', {
    attrs: {
      "group": _vm.group,
      "groupId": _vm.strippedGroupId
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('side-view-chat')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3dabea4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/groupPageView.vue
// module id = 1713
// module chunks = 17